var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn text-white border-0 custom-pointer btn-radius ${
    _vm.btnName != '' ? '' : 'akkurate-small'
  } ${_vm.classes}`,attrs:{"title":_vm.title,"disabled":_vm.disabled},on:{"click":() => _vm.func()}},[(_vm.icon != '')?_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.icon]}}):_vm._e(),(_vm.btnName)?_c('span',{staticClass:"ms-2"},[_vm._v(_vm._s(_vm.btnName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }